import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  propBlue: "#009919",
  heroBackgroundEn: `linear-gradient(180deg, #009919 0%, #064021 116.35%)`,
  heroBackgroundHe: `linear-gradient(180deg, #009919 0%, #064021 116.35%)`,
  heroTextColor: "white",
  heroSvgIconColor: "#fff",
  filterModalHeaderColor: "#009919",
  filterModalHeaderTextColor: "white",
  footerColor: "#009919",
  faqRootBackground: "white",
  faqTextColor: "black",
  faqTextColorExpanded: "#009919",
  faqTextColorHover: "#009919",
  faqRootInsideBackground: "white",
  faqRootInsideBackgroundHover: "white",
  faqRootInsideColorHover: "black",
  faqBorderColor: "white",
  faqIconColor: "#009919",
  faqIconColorAlternative: "black",
  faqBoxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08)",
  navBackgroundColor: "white",
  navTextColor: "black",
  selectedNavTextColor: "#009919",
  selectedSubNavTextColor: "#009919",
  selectedMobileNavTextColor: "black",
  footerSocialsBackgroundColor: "#009919",
  footerLogoLinkBackgroundColor: "white",
  numberGridBackgroundColorEn: "linear-gradient(90deg, #009919 0%, #064021 100%)",
  numberGridBackgroundColorHe: "linear-gradient(90deg, #064021 0%, #009919 100%)",
  numberGridBorderColor: "#009919",
  accordionPanelBackgroundColor: "rgba(0, 0, 0, 0.4)",
  accordionPanelOpenBackgroundColor: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)",
  jobsQuoteGalleryBackgroundColor: "#009919",
  teamContainerBackgroundColor: "#009919",
  buttonHoverBackgroundColor: "#047016",
  buttonActiveBackgroundColor: "#009919",
  buttonHoverTextColor: "white",
  buttonDefaultBackgroundColor: "#009919",
  buttonDisabledBackgroundColor: "#6F6F6F",
  paginationBackgroundColor: "#009919",
  paginationTextColor: "white",
  bulletsBackgoundColor: "#009919",
  marketingBannerBackground: "#009919",
  marketingBannerTextColor: "white",
  heroBgFallback: `linear-gradient(180deg, #009919 0%, #064021 116.35%)`,
}

export default colors
